import * as devisConf from '@/configuration/devisConf';
import formatDate from '@/services/general/formatDate';
import { formatDevise } from '@/services/general/filters/formatDevise';
import i18n from '@/i18n';

function getDates(ligneRegroupement, ligne) {
  if (ligne && ligne.dateDebut && ligne.dateFin) {
    return {
      debut: ligne.dateDebut,
      fin: ligne.dateFin,
    };
  }
  if (ligneRegroupement && ligneRegroupement.dateDebut && ligneRegroupement.dateFin) {
    return {
      debut: ligneRegroupement.dateDebut,
      fin: ligneRegroupement.dateFin,
    };
  }
  return null;
}

function toString(ligneRegroupement, ligne) {
  let libelle = ligne.libelle.trim();
  if (ligneRegroupement) {
    libelle = ligneRegroupement.libelle.trim() + ' - ' + libelle;
  }
  let dates = '';
  if (ligne.ligneReseau?.anneeSemaine) {
    const anneeSemaine = ligne.ligneReseau.anneeSemaine;
    const semaine = anneeSemaine.toString().substring(4, 6);
    const annee = anneeSemaine.toString().substring(0, 4);
    dates += i18n.t('ajoutDevis.popUpLigneWithoutProduct.week', { semaine: semaine, annee: annee });
  }
  const datesLigne = getDates(ligneRegroupement, ligne);
  if (datesLigne) {
    dates += i18n.t('ajoutDevis.popUpLigneWithoutProduct.dates', {
      debut: formatDate(datesLigne.debut),
      fin: formatDate(datesLigne.fin),
    });
  }
  let montants = '';
  if (ligne.quantite || ligne.quantite === 0) montants += i18n.t('ajoutDevis.popUpLigneWithoutProduct.quantite', { quantite: ligne.quantite });
  if (ligne.prixUnitaire || ligne.prixUnitaire === 0) montants += i18n.t('ajoutDevis.popUpLigneWithoutProduct.prix', { prix: formatDevise(ligne.prixUnitaire) });
  if (ligne.totalHt || ligne.totalHt === 0) montants += i18n.t('ajoutDevis.popUpLigneWithoutProduct.total', { total: formatDevise(ligne.totalHt) });

  return '<b>' + libelle + '</b>' + dates + '<br/><i>' + montants + '</i>';
}

export default function checkDcfBeforeSave(dcf) {
  const elementsToCheck = [];
  const banType = [
    devisConf.COMMENTAIRE,
    devisConf.SOUS_TOTAL,
    devisConf.REMISE,
    devisConf.PERSONNALISE,
  ];
  dcf.lignesCommande.forEach(
    (ligne) => {
      if (ligne.lignesCommande) {
        ligne.lignesCommande.forEach((ligneEnfant) => {
          if (ligneEnfant.produitId
            || banType.includes(ligneEnfant.type)) return;
          elementsToCheck.push(toString(ligne, ligneEnfant));
        });
      }
      if (ligne.produitId || banType.includes(ligne.type)) return;
      elementsToCheck.push(toString(null, ligne));
    });
  return elementsToCheck;
}
